if($("#adyen_script").css('display')=='block'){
    $('.pay_box .payment_box .tips').hide()
}
var adyen_dropin = null;
var adyen_checkout = null;
function adyen_destroy(){
    if(adyen_dropin){
        try{ adyen_dropin.remove(); }catch(e){}
        adyen_dropin = null;
    }
    adyen_checkout = null;
    $('#adyen_container').empty();
    $('.pay_box .payment_box .btn').show();
    $('.adyencard_power').show()
    $('.pay_box .payment_box .tips').hide();
}
// https://docs.adyen.com/development-resources/testing/test-card-numbers/
async function adyen_init(data){
    try{
        // v6 通过 window.AdyenWeb 暴露全局变量
        var AdyenCheckout = window.AdyenWeb.AdyenCheckout;
        var Dropin = window.AdyenWeb.Dropin;
        console.log((data.clientKey && data.clientKey.indexOf('live_') >= 0) ? 'live' : 'test');
        var configuration = {
            environment: (data.clientKey && data.clientKey.indexOf('live_') >= 0) ? 'live' : 'test',
            clientKey: data.clientKey,
            session: {
                id: data.sessionId,
                sessionData: data.sessionData
            },
            // countryCode 在 v6 中为必填项
            countryCode: data.countryCode || 'US',
            locale: {en:'en-US', ru:'ru-RU', zh:'zh-CN', 'zh-TW':'zh-TW', ja:'ja-JP', ko:'ko-KR', de:'de-DE', fr:'fr-FR', it:'it-IT', pt:'pt-BR', es:'es-ES', nl:'nl-NL', pl:'pl-PL', sv:'sv-SE', da:'da-DK', fi:'fi-FI', el:'el-GR'}[window.lang] || 'en-US',
            // v6: onPaymentCompleted 仅在支付成功时触发
            onPaymentCompleted: (result, component) => {
                console.log('支付完成:', result);
                handlePaymentResult(result);
            },
            // v6 新增: 支付失败时触发（Cancelled / Error / Refused）
            onPaymentFailed: (result, component) => {
                console.log('支付失败:', result);
                fail();
            },
            onError: (error, component) => {
                console.error('支付错误:', error);
                fail();
            },
            paymentMethodsConfiguration: {
                card: {
                    hasHolderName: false,
                    holderNameRequired: false,
                    billingAddressRequired: false
                }
            }
        };
        // v6: 使用构造函数 new Dropin() 替代 .create('dropin')
        adyen_checkout = await AdyenCheckout(configuration);
        adyen_dropin = new Dropin(adyen_checkout, {
            onReady: function() {
                // adyen 加载成功后的操作
                $('.mask_loading').hide();
                $('.main>.main_loading').removeClass('active');
                $('.pay_box .payment_box .btn').hide()
                $('.adyencard_power').hide()
                $('.pay_box .payment_box .tips').show()
            }
        }).mount('#adyen_container');
    }catch(error){
        console.error('初始化错误:', error);
    }
}
// 生成带混淆参数的 finish 跳转 URL
function buildFinishUrl(orderId) {
    var base = location.href.split('?')[0];
    var encoded = btoa(orderId);

    // 随机生成看起来像业务参数的键名
    function randKey() {
        var prefixes = ['utm_', 'ref_', 'src_', 'trk_', 'ck_', 'ga_', 'fb_', 'ad_'];
        var suffixes = ['id', 'token', 'code', 'key', 'hash', 'sig', 'ts', 'ver'];
        return prefixes[Math.floor(Math.random() * prefixes.length)] +
               suffixes[Math.floor(Math.random() * suffixes.length)];
    }

    // 随机生成看起来像真实值的字符串（混合大小写+数字）
    function randVal(len) {
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var s = '';
        for (var i = 0; i < (len || 12 + Math.floor(Math.random() * 8)); i++) {
            s += chars[Math.floor(Math.random() * chars.length)];
        }
        return s;
    }

    // 构造 3~6 个干扰参数
    var noiseCount = 3 + Math.floor(Math.random() * 4);
    var pairs = [];
    for (var i = 0; i < noiseCount; i++) {
        pairs.push([randKey(), randVal()]);
    }

    // 将 finish 插入随机位置，lang 固定放最后
    var insertAt = Math.floor(Math.random() * (pairs.length + 1));
    pairs.splice(insertAt, 0, ['finish', encoded]);
    if (window.lang) {
        pairs.push(['lang', window.lang]);
    }

    var qs = pairs.map(function(p) {
        // finish 参数用 encodeURIComponent 保护 base64 的 +/= 字符，其余参数直接拼接
        var val = p[0] === 'finish' ? encodeURIComponent(p[1]) : p[1];
        return p[0] + '=' + val;
    }).join('&');

    return base + '?' + qs;
}
// 处理支付结果（v6 中仅处理成功状态，失败由 onPaymentFailed 接管）
function handlePaymentResult(result) {
    console.log('支付结果:', result)
    switch(result.resultCode) {
        case 'Authorised':
            // 支付成功，跳转订单确认页
            if(window.order_id){
                $('.mask_loading').show()
                location.href = buildFinishUrl(window.order_id)
            }
            break;
        case 'Pending':
            // 支付待处理（银行转账等异步方式）
            if(window.order_id){
                $('.mask_loading').show()
                location.href = buildFinishUrl(window.order_id)
            }
            break;
        case 'Received':
            // 待处理或已收到，跳转等待页
            if(window.order_id){
                $('.mask_loading').show()
                location.href = buildFinishUrl(window.order_id)
            }
            break;
        default:
            console.log('未知支付状态，请重试。')
            fail()
            break;
    }
}